/**
 * EMAIL-FORMAT-1 (s236, D-236.38(3), D-236.46(4)) — ONE shared check for every email box.
 *
 * A box whose words have no "@", or no dot after it, gets a quiet line under it ("This doesn't look like an email
 * address") — and the value STILL saves. The company card's "Email or website" box also accepts a web address. The forms
 * that already refuse a bad email (sign-in, sign-up, the admin and advisor forms, the contact page) keep refusing.
 *
 * Extracted from SendToPhoneDialog's isValidEmail (s236), which now reads it from here. Pure.
 */
export const EMAIL_HINT = "This doesn't look like an email address";

/** Something @ something . something, no spaces. A blank is not judged (nothing to hint about). */
export function looksLikeEmail(value: string | null | undefined): boolean {
  const v = (value ?? "").trim();
  return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(v);
}

/** An email, or a web address (company.ca, www.company.ca, https://company.ca/contact). */
export function looksLikeEmailOrWebsite(value: string | null | undefined): boolean {
  const v = (value ?? "").trim();
  return looksLikeEmail(v) || /^(https?:\/\/)?[^\s@/]+\.[a-z]{2,}(\/\S*)?$/i.test(v);
}

/** Whether the quiet line shows under a box holding `value`. A blank box shows nothing. */
export function showEmailHint(value: string | null | undefined, allowWebsite = false): boolean {
  const v = (value ?? "").trim();
  if (!v) return false;
  return !(allowWebsite ? looksLikeEmailOrWebsite(v) : looksLikeEmail(v));
}
